import type { HelpFile } from '../../types/help'
import { LdapConfigCardTestIds } from '../../../testids/LdapConfigCardTestIds'

export const ldapConfigCardHelp: HelpFile = {
  docPage: '/docs/systems/connectors',
  texts: {
    [LdapConfigCardTestIds.ldapConfigCard]:
      'LDAP-Konnektor-Konfiguration — Server-URL, Bind-Anmeldedaten und Such-Basis für die Kommunikation mit dem Verzeichnis.',
    [LdapConfigCardTestIds.cardTitleLdapConfig]: null,
    [LdapConfigCardTestIds.btnCreateLdapConfig]: null,
    [LdapConfigCardTestIds.btnEditLdapConfig]: null,
    [LdapConfigCardTestIds.bindPasswordRef]:
      'Referenz auf das LDAP-Bind-Passwort-Secret.',
    [LdapConfigCardTestIds.selectDirectoryDialect]:
      'Verzeichnistyp. Active Directory sendet userAccountControl=514/512 bei DISABLE/ENABLE_ACCOUNT; OpenLDAP / 389-DS sendet nsAccountLock=TRUE (oder entfernt).',
    [LdapConfigCardTestIds.dlDirectoryDialect]: null,
  },
}
